(function () {
  const MONEY_FORMAT = null;

  function formatMoneyFromCents(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents, MONEY_FORMAT);
      }
    } catch (e) {}
    const euros = (cents / 100).toFixed(2).replace(".", ",");
    return euros + " €";
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("cart.js failed");
    return await res.json();
  }

  function renderOne(bar, cart) {
    const threshold = parseInt(bar.getAttribute("data-threshold-cents"), 10) || 0;
    const total = cart && typeof cart.total_price === "number" ? cart.total_price : 0;

    const remaining = Math.max(threshold - total, 0);
    const progress = threshold > 0 ? Math.min((total / threshold) * 100, 100) : 100;

    const textEl = bar.querySelector("[data-fsb-text]");
    const fillEl = bar.querySelector("[data-fsb-fill]");
    const progEl = bar.querySelector(".fsb__bar");

    const remainingTpl = bar.querySelector("[data-fsb-remaining]");
    const successTpl = bar.querySelector("[data-fsb-success]");

    if (remaining <= 0) {
      textEl.textContent = successTpl ? successTpl.innerHTML.trim() : "Kostenloser Versand erreicht ✅";
    } else {
      const template = remainingTpl ? remainingTpl.innerHTML :  "Noch  bis zum kostenloser Versand";
      textEl.textContent = template.replace("", formatMoneyFromCents(remaining));
    }

    fillEl.style.width = Math.round(progress) + "%";
    if (progEl) progEl.setAttribute("aria-valuenow", String(Math.round(progress)));
  }

  async function updateAll() {
    const bars = document.querySelectorAll("[data-fsb]");
    if (!bars.length) return;

    try {
      const cart = await fetchCart();
      bars.forEach((bar) => renderOne(bar, cart));
    } catch (e) {
      bars.forEach((bar) => {
        const textEl = bar.querySelector("[data-fsb-text]");
        if (textEl) textEl.textContent = "Warenkorb konnte nicht geladen werden";
      });
    }
  }

  // Initial
  document.addEventListener("DOMContentLoaded", updateAll);

  // AJAX Drawer: wenn der Drawer neu gerendert wird, taucht das Element erst danach auf
  const mo = new MutationObserver(() => updateAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Theme events (falls vorhanden)
  document.addEventListener("cart:updated", updateAll);
  document.addEventListener("cart:refresh", updateAll);
  document.addEventListener("theme:cart:change", updateAll);

  // Fallback nach /cart/add|change|update
  const _fetch = window.fetch;
  if (!_fetch.__fsb_patched) {
    window.fetch = function () {
      return _fetch.apply(this, arguments).then((resp) => {
        try {
          const url = (arguments[0] && arguments[0].url) ? arguments[0].url : arguments[0];
          if (
            typeof url === "string" &&
            (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))
          ) {
            setTimeout(updateAll, 150);
          }
        } catch (e) {}
        return resp;
      });
    };
    window.fetch.__fsb_patched = true;
  }
})();
